import React, {Fragment, useState} from 'react';
import PropTypes from 'prop-types';
import Dialog from 'react-bootstrap-dialog';
import {Button, ToggleButtonGroup, ToggleButton, Form, Row, Col, Popover, Modal} from 'react-bootstrap';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import {Formik} from 'formik';
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';
import DatePicker, {registerLocale} from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import it from 'date-fns/locale/it';
import {rtvType, affiliationType} from '../constants';
import {showMessage} from '../actions/messages';
import {useTranslation} from 'react-i18next';
import { MultiSelect } from 'react-multi-select-component';
import {showPlayersModal, hidePlayersModal, cleanPlayersReceived, searchPlayers} from '../actions/partner'
import defaultAvatar from '../images/Replayer_default_Avatar.png'
import binIcon from '../images/bin_icon.svg';
import Configuration from '../config';
import PartnerPlanningGuideModal from './partner-planning-guide-modal';
import SlotMediaStatus from './slot-media-status';
import {FaCalendarAlt, FaCheckCircle, FaInfoCircle, FaLock, FaQuestionCircle, FaSave, FaUsers} from 'react-icons/fa';

registerLocale('it', it);

const Slot = ({slot, save, remove, profile, ownedFields, showMessageRemovingVideo, ownedRtvChannels, showPlayersModal, hidePlayersModal, isPlayersModalVisible, searchPlayers, playersList, affiliations}) => {
  const {t} = useTranslation();
  const hasGroupCoach = affiliations.find(a => a.type === affiliationType.coach && a.active);
  const field = fieldId => ownedFields.find(f => f.id === fieldId); 

  const [selectedPlayers, setSelectedPlayers] = useState(slot.selectedPlayers || []);
  const [selectedPlayer, setSelectedPlayer] = useState({});
  const [pendingStoreOnlyValues, setPendingStoreOnlyValues] = useState(null);
  const [storeOnlySubscriptionChannels, setStoreOnlySubscriptionChannels] = useState([]);
  const [showPlanningGuide, setShowPlanningGuide] = useState(false);

  const getCamerasSelectArray = (cameras, disabled) => {
    let res = [];
    cameras.sort((a,b) => a.position - b.position).forEach(c => {
      res.push({label: c.name, value: c.id, disabled: disabled})
    });
    return res;
  };

  const selectedField = field(slot.fieldId);
  const videoRecordingEnabled = Boolean(selectedField && selectedField.recording);
  const rtvPublishingEnabled = Boolean(videoRecordingEnabled && selectedField.rtv);
  const cameraOptions = getCamerasSelectArray(selectedField.cameras, slot.slotId && new Date(slot.startDatetime) < new Date());

  const rtvChannelsTypes = {
    "replayerVideo": 0,
    "partnerVideo": 1,
  };
  const replayerVideoChannels = ownedRtvChannels.filter(c => c.type === rtvChannelsTypes.replayerVideo);
  const savePendingStoreOnly = rtvChannels => {
    if (!pendingStoreOnlyValues) {
      return;
    }
    save({
      ...pendingStoreOnlyValues,
      rtvChannels: rtvChannels.map(channel => ({...channel, canPublish: false}))
    }, selectedPlayers);
    setPendingStoreOnlyValues(null);
    setStoreOnlySubscriptionChannels([]);
  };

  return (
    <Fragment>
      <Formik
        enableReinitialize
        initialValues={Object.assign(
          {},
          slot,
          {untilDate: slot.endDatetime, overwriting: false, weekDays: [], remove: false, event: slot.event || false, presetPlaces: slot.presetPlaces || 1, color: slot.color || '#ADB5BD', minimumPlayers: slot.minimumPlayers || null, doublesDiscountEnabled: Boolean(slot.doublesDiscountEnabled), doublesDiscountPercent: slot.doublesDiscountPercent || 0, selectedCameras: slot.selectedCameras || cameraOptions.filter(o => o.value === field(slot.fieldId).cameras.filter(c => c.position === 1)[0].id), public: slot.public, costIds: slot.costIds || [], costs: slot.costs || []}
        )}
        onSubmit={values => {
          const submittedValues = videoRecordingEnabled ? values : {
            ...values,
            videoSellPermission: false,
            rtvOrAcademy: null,
            rtvChannels: [],
            selectedCameras: []
          };
          if (
            rtvPublishingEnabled
            && !submittedValues.remove
            && submittedValues.videoSellPermission
            && submittedValues.rtvOrAcademy !== rtvType.academy
            && (!submittedValues.rtvChannels || submittedValues.rtvChannels.length === 0)
            && replayerVideoChannels.length > 0
          ) {
            setPendingStoreOnlyValues(submittedValues);
            setStoreOnlySubscriptionChannels([]);
            return;
          }
          return submittedValues.remove ? remove(submittedValues) : save(submittedValues, selectedPlayers);
        }}
      >
        {({
          handleSubmit,
          handleChange,
          setFieldValue,
          values
        }) => {
          const setVideoSellPermissionByState = state => {
            if (state.target.value === 'available') {
              setFieldValue('videoSellPermission', videoRecordingEnabled);
              setFieldValue('public', null);
              if (!rtvPublishingEnabled) {
                setFieldValue('rtvChannels', []);
                setFieldValue('rtvOrAcademy', null);
              }
            }

            if(state.target.value === 'reserved') {
              setFieldValue('videoSellPermission', false);
            }

            if (state.target.value !== 'available') {
              setFieldValue('doublesDiscountEnabled', false);
              setFieldValue('doublesDiscountPercent', 0);
            }

            handleChange(state);
          };

          let dialog = null;
          const onRemoveVideo = (message, fieldName, newValue) => {
            dialog.show({
              title: t('CONFIRM'),
              body: message,
              actions: [
                Dialog.Action(
                  t('OK'),
                  () => setFieldValue(fieldName, newValue),
                  'btn btn-secondary'
                ),
                Dialog.Action(
                  t('CANCEL'),
                  null,
                  'btn btn_red_outline_rp'
                )
              ],
              bsSize: 'small',
              onHide: dialog => {
                dialog.hide();
              }
            });
          };

          const renderPlayer = (players) => {
            return(
              <div>
                <ul class="list-group list-group-light mb-4">
                  {
                    players.map( (p, index) =>
                      <li class="list-group-item d-flex justify-content-between align-items-center">
                        <div class="d-flex align-items-center">
                          {p.image && p.image[0] ?
                          <img
                            className="img-fluid"
                            src={`${Configuration.apiEndPoint}/images/${p.uid}?load=${p.image[0]}`}
                            alt={t('PROFILE_IMAGE')}
                            style={{width: 45, height: 45, paddingLeft:0}}
                            class="rounded-circle"
                          />
                          :
                          <img
                            className="img-fluid"
                            src={defaultAvatar}
                            alt={t('PROFILE_IMAGE')}
                            style={{width: 45, height: 45, paddingLeft:0}}
                            class="rounded-circle"
                          />
                          }
                          <div class="ms-3">
                            <p class="fw-bold mb-1" style={{marginLeft: 10}}>{p.name + " " + p.surname}</p>
                            <p class="fw-bold mb-1" style={{marginLeft: 10}}>{p.nickname}</p>
                          </div>
                        </div>
                        <li className="card_video_archive_list_icons_item"><button type="button" style={{background: "transparent", border: 0, padding: 0}} onClick={() => players.splice(index, 1)}><img src={binIcon} alt={t('ICON_DELETE')}/></button></li>
                      </li>
                    )
                  }
                </ul>
              </div>
            )
          }

          const changePresetPlaces = (value) => {
            if(field(values.fieldId).payment && field(values.fieldId).unbookableHours != null){
              if(values.presetPlaces === 1 && value > 1){
                setFieldValue('minimumPlayers', 0);
              }
              else if(values.presetPlaces > 1 && value === 1){
                setFieldValue('minimumPlayers', null);
              }
            }
            if (value !== 4) {
              setFieldValue('doublesDiscountEnabled', false);
              setFieldValue('doublesDiscountPercent', 0);
            }
            setFieldValue('presetPlaces', value)
          };

          return (
            <Form onSubmit={handleSubmit} className="partner-slot-planning-form">
              <SlotMediaStatus slotId={slot.slotId}/>
              <div className="partner-slot-planning-intro">
                <div>
                  <small>{t('FIELD_PLANNING')}</small>
                  <h3>{values.slotId ? t('EDIT_SLOT') : t('CREATE_SLOT')}</h3>
                  <p>{t('FIELD_PLANNING_INTRO')}</p>
                </div>
                <Button className="partner-planning-guide-button" size="sm" onClick={() => setShowPlanningGuide(true)}>
                  <FaQuestionCircle/> {t('PLANNING_GUIDE')}
                </Button>
              </div>
              <section className="partner-slot-planning-section">
                <div className="partner-slot-planning-section__heading">
                  <span>1</span>
                  <div><h4>{t('SLOT_TYPE_QUESTION')}</h4><p>{t('FIELD_SLOT_TYPE_HELP')}</p></div>
                </div>
                <Form.Group className="partner-slot-state-field">
                <Form.Label>{t('SLOT_TYPE')}*</Form.Label>
                <Form.Control required as="select" name="state" value={values.state || ''} onChange={setVideoSellPermissionByState}>
                  <option value="">{t('GIVE_STATE')}</option>
                  <option value="available">{t('AVAILABLE')}</option>
                  <option value="reserved">{t('RESERVED')}</option>
                  <option value="unavailable">{t('UNAVAILABLE')}</option>
                </Form.Control>
              </Form.Group>
              <div className={`partner-slot-state-help partner-slot-state-help--${values.state || 'empty'}`}>
                {values.state === 'available' ? <><FaUsers/><div><strong>{t('SLOT_AVAILABLE_TITLE')}</strong><span>{t('FIELD_SLOT_AVAILABLE_HELP')}</span></div></> : null}
                {values.state === 'reserved' ? <><FaCalendarAlt/><div><strong>{t('SLOT_RESERVED_TITLE')}</strong><span>{t('FIELD_SLOT_RESERVED_HELP')}</span></div></> : null}
                {values.state === 'unavailable' ? <><FaLock/><div><strong>{t('FIELD_UNAVAILABLE_TITLE')}</strong><span>{t('FIELD_UNAVAILABLE_HELP')}</span></div></> : null}
                {!values.state ? <><FaInfoCircle/><div><strong>{t('CHOOSE_SLOT_TYPE_FIRST')}</strong><span>{t('FIELD_CHOOSE_SLOT_TYPE_HELP')}</span></div></> : null}
              </div>
              </section>
              <section className="partner-slot-planning-section">
              <div className="partner-slot-planning-section__heading">
                <span>2</span>
                <div><h4>{t('WHEN_DOES_IT_TAKE_PLACE')}</h4><p>{t('SLOT_TIME_HELP')}</p></div>
              </div>
              <Form.Row className="partner-slot-time-row">
                <Col>
                  <Form.Group>
                    <Form.Label>{t('START_TIME')}*</Form.Label><br/>
                    <DatePicker
                      required
                      showTimeSelect
                      showTimeSelectOnly
                      locale="it"
                      className="form-control"
                      timeFormat="HH:mm"
                      dateFormat="HH:mm"
                      timeIntervals={15}
                      selected={(values.startDatetime && new Date(values.startDatetime)) || null}
                      onChange={val => {
                        if (slot.startDatetime && val) {
                          const newDate = new Date(slot.startDatetime);
                          newDate.setHours(val.getHours());
                          newDate.setMinutes(val.getMinutes());
                          setFieldValue('startDatetime', newDate);
                        } else {
                          setFieldValue('startDatetime', val);
                        }
                      }}/>
                  </Form.Group>
                </Col>
                <Col>
                  <Form.Group>
                    <Form.Label>{t('FINISH_TIME')}*</Form.Label><br/>
                    <DatePicker
                      required
                      showTimeSelect
                      showTimeSelectOnly
                      locale="it"
                      className="form-control"
                      timeFormat="HH:mm"
                      dateFormat="HH:mm"
                      timeIntervals={15}
                      selected={(values.endDatetime && new Date(values.endDatetime)) || null}
                      onChange={val => {
                        if (slot.endDatetime && val) {
                          const newDate = new Date(slot.endDatetime);
                          newDate.setHours(val.getHours());
                          newDate.setMinutes(val.getMinutes());
                          setFieldValue('endDatetime', newDate);
                        } else {
                          setFieldValue('endDatetime', val);
                        }

                        if (val) {
                          const newUntilDate = new Date(values.untilDate);
                          newUntilDate.setHours(val.getHours());
                          newUntilDate.setMinutes(val.getMinutes());
                          setFieldValue('untilDate', newUntilDate);
                        }
                      }}/>
                  </Form.Group>
                </Col>
              </Form.Row>
              <Form.Row className="align-items-center">
                <Col>
                  <Form.Group>
                    <Form.Label>{t('REPEAT')}</Form.Label><br/>
                    <DatePicker
                      required
                      locale="it"
                      className="form-control"
                      dateFormat="dd/MM/yyyy"
                      selected={(values.untilDate && new Date(values.untilDate)) || null}
                      onChange={val => setFieldValue('untilDate', val)}/>
                  </Form.Group>
                </Col>
                <Col className="d-flex flex-column">
                  <Form.Group>
                    <Form.Check style={{marginTop: 10, marginLeft: 20}} name="overwriting-remove" type="radio" label={t('KEEP')} checked={!values.overwriting} onChange={() => {setFieldValue('overwriting', !(values.overwriting)); setFieldValue('remove', false);}}/>
                    <Form.Check style={{marginLeft: 20}} name="overwriting-remove" type="radio" label={t('OVERWRITE')} checked={values.overwriting} onChange={() => {setFieldValue('overwriting', !(values.overwriting)); setFieldValue('remove', false);}}/>
                    {
                      values.slotId ?
                        <Form.Check style={{marginLeft: 20}} name="overwriting-remove" type="radio" label={t('DELETE')} checked={values.remove} onChange={() => setFieldValue('remove', !(values.remove))}/> :
                        null
                    }
                  </Form.Group>
                </Col>
              </Form.Row>
              <Form.Row>
                <Col>
                  <ToggleButtonGroup name="weekDays" type="checkbox" value={values.weekDays} onChange={weekDays => setFieldValue('weekDays', weekDays)}>
                    <ToggleButton
                      type="checkbox"
                      variant="success"
                      value={0}
                      size="sm"
                    >
                      {t('MONDAY')}
                    </ToggleButton>
                    <ToggleButton
                      type="checkbox"
                      variant="success"
                      value={1}
                      size="sm"
                    >
                      {t('TUESDAY')}
                    </ToggleButton>
                    <ToggleButton
                      type="checkbox"
                      variant="success"
                      value={2}
                      size="sm"
                    >
                      {t('WEDNESDAY')}
                    </ToggleButton>
                    <ToggleButton
                      type="checkbox"
                      variant="success"
                      value={3}
                      size="sm"
                    >
                      {t('THURSDAY')}
                    </ToggleButton>
                    <ToggleButton
                      type="checkbox"
                      variant="success"
                      value={4}
                      size="sm"
                    >
                      {t('FRIDAY')}
                    </ToggleButton>
                    <ToggleButton
                      type="checkbox"
                      variant="success"
                      value={5}
                      size="sm"
                    >
                      {t('SATURDAY')}
                    </ToggleButton>
                    <ToggleButton
                      type="checkbox"
                      variant="success"
                      value={6}
                      size="sm"
                    >
                      {t('SUNDAY')}
                    </ToggleButton>
                  </ToggleButtonGroup>
                </Col>
              </Form.Row>
              <div className="partner-slot-repeat-note"><FaInfoCircle/> {t('SLOT_REPEAT_NOTE')}</div>
              </section>
              {values.state ? <div className="partner-slot-planning-section__heading partner-slot-planning-section__heading--configuration">
                <span>3</span>
                <div><h4>{values.state === 'available' ? t('CONFIGURE_BOOKING_AND_PRICE') : values.state === 'reserved' ? t('CONFIGURE_RESERVED_SLOT') : t('COMPLETE_FIELD_BLOCK')}</h4><p>{values.state === 'available' ? t('CONFIGURE_FIELD_BOOKING_HELP') : values.state === 'reserved' ? t('CONFIGURE_RESERVED_SLOT_HELP') : t('CHECK_BEFORE_SAVING')}</p></div>
              </div> : null}
              {
                values.state === 'reserved' ?
                  <Fragment>
                    {videoRecordingEnabled ? <Form.Group>
                      <Form.Check
                        name="videoSellPermission"
                        type="checkbox"
                        label={t('SALABLE_VIDEO')}
                        checked={values.videoSellPermission}
                        onChange={() => {
                          const newValue = !values.videoSellPermission;
                          if (!newValue) {
                            onRemoveVideo(t('VIDEO_PARTNER_REMOVING_SALABLE'), 'videoSellPermission', newValue);
                          } else {
                            setFieldValue('videoSellPermission', newValue);
                          }
                          if (newValue && values.rtvOrAcademy === rtvType.academy) {
                            setFieldValue('rtvOrAcademy', null);
                          }
                        }}
                      />
                      <div className="partner-slot-video-explanation">
                        <FaInfoCircle />
                        <div>
                          <strong>{t('SINGLE_VIDEO_SALE')}</strong>
                          <span>{t('SINGLE_VIDEO_SALE_HELP')}</span>
                        </div>
                      </div>
                    </Form.Group> : null}
                    {
                      values.videoSellPermission ?
                      <Fragment>
                        <Form.Group>
                          <Form.Label>{t('VIDEO_VISIBILITY')}</Form.Label>
                          <Form.Check required name="public" type="radio" label={t('PUBLIC')} checked={values.public} onChange={() => setFieldValue('public', true)}/>
                          <Form.Check required name="public" type="radio" label={t('PRIVATE')} checked={values.public === false} onChange={() => setFieldValue('public', false)}/>
                        </Form.Group>
                        {values.public === false ?
                        <Form.Group>
                          <Form.Label>{t('PLAYERS_SELECTION')}</Form.Label>
                          {renderPlayer(selectedPlayers)}
                          <Button variant="secondary" onClick={showPlayersModal}>{t('ADD_PLAYER')}</Button>
                        </Form.Group>
                      : null}
                      </Fragment>
                    : null}
                    {
                      rtvPublishingEnabled && replayerVideoChannels.length > 0 ?
                        <Fragment>
                          <div className="partner-slot-video-explanation">
                            <FaInfoCircle />
                            <div>
                              <strong>{t('REPLAYERTV_PUBLISHING')}</strong>
                              <span>{t('REPLAYERTV_PUBLISHING_HELP')}</span>
                            </div>
                          </div>
                          {replayerVideoChannels.map(c => (
                            <Form.Group>
                              <Form.Check
                                type="checkbox"
                                label={`Rtv ${c.name}`}
                                checked={values.rtvChannels.some(channel => channel.id === c.id)}
                                onChange={() => {
                                  if (values.rtvChannels.some(channel => channel.id === c.id)) {
                                    setFieldValue('rtvChannels', values.rtvChannels.filter(channel => channel.id !== c.id));
                                  } else {
                                    setFieldValue('rtvChannels', [...values.rtvChannels, c]);
                                    setFieldValue('rtvOrAcademy', null);
                                  }
                                }}/>
                            </Form.Group>
                          ))}
                          {
                            hasGroupCoach ?
                              <Form.Group>
                                <Form.Check
                                  type="checkbox"
                                  label="Academy"
                                  checked={values.rtvOrAcademy === rtvType.academy}
                                  onChange={() => {
                                    if (values.rtvOrAcademy === rtvType.academy) {
                                      onRemoveVideo(t('VIDEO_PARTNER_REMOVING_RTV'), 'rtvOrAcademy', null);
                                    } else {
                                      const newValue = values.rtvOrAcademy === rtvType.academy ? null : rtvType.academy;
                                      setFieldValue('rtvOrAcademy', newValue);
                                      if (newValue === rtvType.academy) {
                                        setFieldValue('videoSellPermission', false);
                                        setFieldValue('rtvChannels', []);
                                      }
                                    }
                                  }}/>
                              </Form.Group> :
                              null
                          }
                        </Fragment> :
                        null
                    }
                    <Form.Group>
                      <Form.Check
                        name="event"
                        type="checkbox"
                        label={t('SPECIAL_EVENT')}
                        checked={values.event}
                        onChange={() => setFieldValue('event', !(values.event && values.event))}
                      />
                    </Form.Group>
                    {videoRecordingEnabled && cameraOptions.length > 0 && (values.videoSellPermission || values.rtvChannels.length > 0 || values.rtvOrAcademy === rtvType.academy) ?
                      <Form.Group>
                        <Form.Label>{t('CAMERAS')}</Form.Label>
                        <div style={{color: 'black'}}>
                          <MultiSelect
                            options={cameraOptions}
                            value={values.selectedCameras}
                            onChange={value => setFieldValue('selectedCameras', value)}
                            labelledBy="SelectCamera"
                            overrideStrings={{
                              "allItemsAreSelected": t('ALL_CAMERAS'),
                              "search": t('SEARCH'),
                              "selectAll": t('SELECT_ALL'),
                              "selectSomeItems": t('CAMERA_SELECT'),
                              "selectAllFiltered": t('SELECT_ALL'),
                            }}
                            ClearSelectedIcon={null}
                          />
                          <input
                            name="hiddenRequired"
                            style={{ height: 0, width: 0, opacity: 0}}
                            value={values.selectedCameras.length ? "1" : ""}
                            required
                          />
                        </div>
                      </Form.Group>
                    : null}
                    <Form.Group>
                      <Form.Label>{t('TAG_COLOR')}*</Form.Label><br />                    
                          <OverlayTrigger
                            trigger="click"
                            key="bottom"                          
                            placement="bottom"
                            overlay={
                              <Popover>
                                <Popover.Title as="h3">{t('TAG_COLOR')}</Popover.Title>
                                <Popover.Content>
                                  <Row style={{marginBottom: 10}}>
                                    <Col><Button style={{backgroundColor: '#E53935', border: 0, height: 25}} onClick={() => setFieldValue('color', '#E53935')}/></Col>
                                    <Col><Button style={{backgroundColor: '#D81B60', border: 0, height: 25}} onClick={() => setFieldValue('color', '#D81B60')}/></Col>
                                    <Col><Button style={{backgroundColor: '#8E24AA', border: 0, height: 25}} onClick={() => setFieldValue('color', '#8E24AA')}/></Col>
                                    <Col><Button style={{backgroundColor: '#5E35B1', border: 0, height: 25}} onClick={() => setFieldValue('color', '#5E35B1')}/></Col>
                                    <Col><Button style={{backgroundColor: '#9D86C3', border: 0, height: 25}} onClick={() => setFieldValue('color', '#9D86C3')}/></Col>                                  
                                  </Row>
                                  <Row>                                  
                                    <Col><Button style={{backgroundColor: '#FFB300', border: 0, height: 25}} onClick={() => setFieldValue('color', '#FFB300')}/></Col>                                  
                                    <Col><Button style={{backgroundColor: '#FB8C00', border: 0, height: 25}} onClick={() => setFieldValue('color', '#FB8C00')}/></Col>
                                    <Col><Button style={{backgroundColor: '#F4511E', border: 0, height: 25}} onClick={() => setFieldValue('color', '#F4511E')}/></Col>
                                    <Col><Button style={{backgroundColor: '#AB6158', border: 0, height: 25}} onClick={() => setFieldValue('color', '#AB6158')}/></Col>
                                    <Col><Button style={{backgroundColor: '#ADB5BD', border: 0, height: 25}} onClick={() => setFieldValue('color', '#ADB5BD')}/></Col>
                                  </Row>
                                </Popover.Content>
                              </Popover>
                            }
                          >
                            <Button block size='lg' style={{backgroundColor: values.color, border: 0, height: 25}}/>
                          </OverlayTrigger>
                    </Form.Group>
                  </Fragment> :
                  null
              }
              {
                values.state === 'available' ?
                  <Fragment>
                    <Form.Group>
                      <Form.Label>{t('PRICE')}</Form.Label>
                      <Form.Control required={field(values.fieldId).payment} name="price" type="number" min="0.00" step="any" value={values.price || ''} onChange={handleChange}/>
                    </Form.Group>
                    {
                      rtvPublishingEnabled && ownedRtvChannels.filter(c => c.type === rtvChannelsTypes.replayerVideo).length > 0 ?
                        <Form.Label>{t('ALLOW_PUBLICATION_ON')}</Form.Label>
                        :
                        null
                    }
                    {rtvPublishingEnabled ? ownedRtvChannels.filter(c => c.type === rtvChannelsTypes.replayerVideo).map(c => (
                      <Form.Group key={c.id}>
                        <Form.Check
                          type="checkbox"
                          label={`Rtv ${c.name}`}
                          checked={values.rtvChannels.some(channel => channel.id === c.id)}
                          onChange={() => {
                            if (values.rtvChannels.some(channel => channel.id === c.id)) {
                              setFieldValue('rtvChannels', values.rtvChannels.filter(channel => channel.id !== c.id));
                            } else {
                              setFieldValue('rtvChannels', [...values.rtvChannels, c]);
                            }
                          }}/>
                      </Form.Group>
                    )) : null}
                    {videoRecordingEnabled && cameraOptions.length > 0 ?
                      <Form.Group>
                        <Form.Label>{t('CAMERAS')}</Form.Label>
                        <div style={{color: 'black'}}>
                          <MultiSelect
                            options={cameraOptions}
                            value={values.selectedCameras}
                            onChange={value => setFieldValue('selectedCameras', value)}
                            labelledBy="SelectCamera"
                            overrideStrings={{
                              "allItemsAreSelected": t('ALL_CAMERAS'),
                              "search": t('SEARCH'),
                              "selectAll": t('SELECT_ALL'),
                              "selectSomeItems": t('CAMERA_SELECT'),
                              "selectAllFiltered": t('SELECT_ALL'),
                            }}
                            ClearSelectedIcon={null}
                          />
                          <input
                            name="hiddenRequired"
                            style={{ height: 0, width: 0, opacity: 0}}
                            value={values.selectedCameras.length ? "1" : ""}
                            required
                          />
                        </div>
                      </Form.Group>
                    : null}
                    <Form.Group>
                      <Form.Label>{t('PLACES')}</Form.Label>
                      <Form.Control name="presetPlaces" type="number" min="1" max="30" step="1" value={values.presetPlaces || 1} onChange={v => changePresetPlaces(Number(v.target.value))}/>
                    </Form.Group>
                  </Fragment> :
                  null
              }
              {
                values.state === 'reserved' || values.state === 'unavailable' ?
                  <Form.Group>
                    <Form.Label>{t('DESCRIPTION')}*</Form.Label>
                    <Form.Control required name="description" as="textarea" maxLength={255} placeholder={t('DESCRIPTION')}value={values.description || ''} onChange={handleChange}/>
                  </Form.Group>
                : null
              }
              {
                values.state === 'available' && values.presetPlaces > 1 && field(values.fieldId).payment && field(values.fieldId).unbookableHours != null ?
                  <Form.Group>
                    <Form.Label>{t('BOOKING_TYPE')}*</Form.Label>
                      <Form.Check required name="groupBooking" type="radio" label={t('INDIVIDUAL_BOOKING')} checked={values.minimumPlayers === null} onChange={() => {
                        setFieldValue('minimumPlayers', null);
                        setFieldValue('doublesDiscountEnabled', false);
                        setFieldValue('doublesDiscountPercent', 0);
                      }}/>
                      <Form.Check required name="groupBooking" type="radio" label={t('GROUP_BOOKING')} checked={values.minimumPlayers !== null} onChange={() => setFieldValue('minimumPlayers', 0)}/>
                  </Form.Group>
                : null
              }
              {
                values.state === 'available' && values.minimumPlayers !== null && values.presetPlaces > 1?
                <Form.Group>
                  <Form.Label>{t('MINIMUM_PLAYERS')}</Form.Label>
                  <Form.Control name="minimumPlayers" type="number" min="1" max={values.presetPlaces} step="1" value={values.minimumPlayers} onChange={event => {
                    const minimumPlayers = Number(event.target.value);
                    setFieldValue('minimumPlayers', minimumPlayers);
                    if (minimumPlayers !== 2) {
                      setFieldValue('doublesDiscountEnabled', false);
                      setFieldValue('doublesDiscountPercent', 0);
                    }
                  }}/>
                </Form.Group>
                : null
              }
              {
                values.state === 'available' && values.presetPlaces === 4 && Number(values.minimumPlayers) === 2 ?
                  <Form.Group className="partner-slot-doubles-discount">
                    <Form.Check
                      name="doublesDiscountEnabled"
                      type="checkbox"
                      label={t('DOUBLES_DISCOUNT_ENABLE')}
                      checked={Boolean(values.doublesDiscountEnabled)}
                      onChange={event => {
                        const enabled = event.target.checked;
                        setFieldValue('doublesDiscountEnabled', enabled);
                        if (!enabled) setFieldValue('doublesDiscountPercent', 0);
                      }}
                    />
                    <Form.Text className="text-muted">{t('DOUBLES_DISCOUNT_PLANNING_HELP')}</Form.Text>
                    {values.doublesDiscountEnabled ? (
                      <Fragment>
                        <Form.Label>{t('DOUBLES_DISCOUNT_PERCENT')}*</Form.Label>
                        <Form.Control
                          required
                          name="doublesDiscountPercent"
                          type="number"
                          min="1"
                          max="100"
                          step="1"
                          value={values.doublesDiscountPercent || ''}
                          onChange={handleChange}
                        />
                      </Fragment>
                    ) : null}
                  </Form.Group>
                : null
              }
              {
                values.state === 'available' && ((field(values.fieldId).costs && field(values.fieldId).costs.length > 0) || (values.costs && values.costs.length > 0)) && (values.presetPlaces === 1 || (values.presetPlaces > 1 && values.minimumPlayers !== null)) ?
                  <Form.Group>
                    <Form.Label>{t('FIXED_COSTS')}</Form.Label>
                    {field(values.fieldId).costs.map(c => (
                      <Form.Check 
                      type="checkbox" 
                      label={c.name + ` (${c.hourPrice}€/h)`}
                      checked={values.costIds.includes(c.id)} 
                      onChange={() => {
                        if (values.costIds.includes(c.id)) {
                          setFieldValue('costIds', values.costIds.filter(id => id !== c.id));
                        } else {
                          setFieldValue('costIds', [...values.costIds, c.id]);
                        }
                      }}/>
                    ))}
                    {
                      values.costs.map(c => (
                        !(field(values.fieldId).costs.map(fc => fc.id).includes(c.costId)) ?
                          <Form.Check
                            type="checkbox" 
                            label={c.name+ ` (${c.hourPrice}€/h)`} 
                            checked={values.costIds.includes(c.costId)} 
                            onChange={() => {
                              if (values.costIds.includes(c.costId)) {
                                setFieldValue('costIds', values.costIds.filter(id => id !== c.costId));
                              } else {
                                setFieldValue('costIds', [...values.costIds, c.costId]);
                              }
                            }}/>
                        : null  
                    ))}
                  </Form.Group>
                : null
              }
              {
                values.state === 'available' && values.presetPlaces > 1 ?
                  <Form.Group>
                    <Form.Label>{t('DESCRIPTION')}</Form.Label>
                    <Form.Control name="description" as="textarea" maxLength={255} placeholder={t('DESCRIPTION')}value={values.description || ''} onChange={handleChange}/>
                  </Form.Group>
                : null
              }
              <div className="partner-slot-planning-summary">
                <FaCheckCircle/>
                <div><strong>{t('BEFORE_CONFIRMING')}</strong><span>{t('FIELD_BEFORE_CONFIRMING_HELP')}</span></div>
              </div>
              <Button type="submit" className={`partner-slot-planning-submit${values.remove ? ' partner-slot-planning-submit--remove' : ''}`}>
                {values.remove ? t('DELETE') : <><FaSave/> {t('SAVE_PLANNING')}</>}
              </Button>
              <Dialog
                ref={el => {
                  dialog = el;
                }}/>
            </Form>
          );
        }}
      </Formik>
      <PartnerPlanningGuideModal
        show={showPlanningGuide}
        onHide={() => setShowPlanningGuide(false)}
        includeVideoOptions
      />
      <Modal show={Boolean(pendingStoreOnlyValues)} onHide={() => setPendingStoreOnlyValues(null)}>
        <Modal.Header closeButton>
          <Modal.Title>{t('INCLUDE_VIDEO_IN_RTV_SUBSCRIPTION')}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>{t('RTV_SUBSCRIPTION_LINK_HELP')}</p>
          <p>{t('RTV_SINGLE_PURCHASE_FALLBACK')}</p>
          <Form.Group>
            <Form.Label>{t('INCLUDE_FOR_SUBSCRIBERS_TO')}</Form.Label>
            {replayerVideoChannels.map(channel => (
              <Form.Check
                key={channel.id}
                type="checkbox"
                label={channel.name}
                checked={storeOnlySubscriptionChannels.some(selected => selected.id === channel.id)}
                onChange={() => {
                  if (storeOnlySubscriptionChannels.some(selected => selected.id === channel.id)) {
                    setStoreOnlySubscriptionChannels(storeOnlySubscriptionChannels.filter(selected => selected.id !== channel.id));
                  } else {
                    setStoreOnlySubscriptionChannels([...storeOnlySubscriptionChannels, channel]);
                  }
                }}
              />
            ))}
            <Form.Text className="text-muted">
              {t('RTV_STORE_ONLY_NOTE')}
            </Form.Text>
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="outline-secondary" onClick={() => setPendingStoreOnlyValues(null)}>
            {t('CANCEL')}
          </Button>
          <Button variant="outline-danger" onClick={() => savePendingStoreOnly([])}>
            {t('SAVE_SINGLE_PURCHASE_ONLY')}
          </Button>
          <Button
            variant="primary"
            disabled={storeOnlySubscriptionChannels.length === 0}
            onClick={() => savePendingStoreOnly(storeOnlySubscriptionChannels)}
          >
            {t('LINK_AND_SAVE')}
          </Button>
        </Modal.Footer>
      </Modal>
      {isPlayersModalVisible ?
        <Modal show={isPlayersModalVisible} onHide={hidePlayersModal}>
          <Modal.Header closeButton>
            <Modal.Title>{t('ADD_PLAYER')}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Formik
                enableReinitialize
                initialValues={{selectedPlayers}}
                onSubmit={values => setSelectedPlayers(values.selectedPlayers)}
              >
                {({
                  handleSubmit,
                  setFieldValue,
                  handleChange,
                  values
                }) => {

                const addInvitedPlayer = (player) => {
                  let alreadyInvited = false;
                  values.selectedPlayers.forEach(p => {
                    if(p.uid === player.uid) alreadyInvited = true;
                  });
                  if(!alreadyInvited) values.selectedPlayers.push(player);
                  setSelectedPlayer({});
                  values.playerName = "";
                  values.playerSurname = "";
                  values.playerNickname = "";
                  hidePlayersModal();
                };

                const renderPlayerSearch = player => {
                  return(
                    <div key={player.uid}>
                      <ul class="list-group list-group-light mb-4">
                        <li class="list-group-item d-flex justify-content-between align-items-center">
                          <div class="d-flex align-items-center">
                            {player && player.image && player.image[0] ?
                            <img
                              className="img-fluid"
                              src={`${Configuration.apiEndPoint}/images/${player.uid}?load=${player.image[0]}`}
                              alt={t('PROFILE_IMAGE')}
                              style={{width: 45, height: 45, paddingLeft:0}}
                              class="rounded-circle"
                            />
                            :
                            <img
                              className="img-fluid"
                              src={defaultAvatar}
                              alt={t('PROFILE_IMAGE')}
                              style={{width: 45, height: 45, paddingLeft:0}}
                              class="rounded-circle"
                            />
                            }
                            <div class="ms-3">
                              <p class="fw-bold mb-1" style={{marginLeft: 10}}>{player.name + " " + player.surname}</p>
                              <p class="fw-bold mb-1" style={{marginLeft: 10}}>{player.nickname + (player.groupType ? " - " + player.groupType : "")}</p>
                            </div>
                          </div>
                          <Form.Check required name="selectedPlayer" type="radio" onChange={() => setSelectedPlayer(player)}/>
                        </li>
                      </ul>
                    </div>
                  )
                }

                return(
                  <Form onSubmit={handleSubmit}>
                      <Fragment>
                        <p>{t('THREE_CHAR_MINIMUM')}</p>
                        <Form.Group style={{display: 'flex', flexDirection: 'row'}} required>
                          <Form.Control name="playerNickname" style={{maxWidth: 150}} placeholder={t('NICKNAME')} type="text" maxLength="25" minLength="3" value={values.playerNickname || ""} onChange={handleChange}/>
                          <Form.Control name="playerName" style={{maxWidth: 150}} placeholder={t('NAME')} type="text" maxLength="25" minLength="3" value={values.playerName || ""} onChange={handleChange}/>
                          <Form.Control name="playerSurname" style={{maxWidth: 150}} placeholder={t('SURNAME')} type="text" maxLength="25" minLength="3" value={values.playerSurname || ""} onChange={handleChange}/>
                        </Form.Group>
                        <Form.Group style={{display: 'flex', justifyContent: 'space-between'}}>
                          <Form.Check name="playerAffiliate" type="checkbox" label={t('PLAYER_AFFILIATE',{partner: profile.name})} checked={values.playerAffiliate === true} onChange={() => setFieldValue('playerAffiliate', !values.playerAffiliate)}/>
                          <Button disabled={!((values.playerNickname && values.playerNickname.length > 2) || (values.playerName && values.playerName.length > 2) || (values.playerSurname && values.playerSurname.length > 2))} variant="secondary" onClick={() => searchPlayers(values.playerNickname, values.playerName, values.playerSurname, values.playerAffiliate)}>{t('SEARCH')}</Button>
                        </Form.Group>
                        <Form.Group style={{display: 'flex', flexDirection: 'column'}}>
                        {playersList.map(p => 
                          renderPlayerSearch(p)
                        )}
                        <Button style={{maxWidth: 100}}disabled={selectedPlayer.uid === undefined} variant="secondary" onClick={() => addInvitedPlayer(selectedPlayer)}>{t('SELECT')}</Button>
                        </Form.Group>
                      </Fragment>
                  </Form>
                )}}
            </Formik>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="primary" onClick={hidePlayersModal}>
              {t('CLOSE_BUTTON')}
            </Button>
          </Modal.Footer>
        </Modal>
      : null}
    </Fragment>
  );
};

Slot.propTypes = {
  slot: PropTypes.object,
  ownedFields: PropTypes.array,
  save: PropTypes.func.isRequired,
  remove: PropTypes.func.isRequired,
  profile: PropTypes.object.isRequired,
  showMessageRemovingVideo: PropTypes.func.isRequired,
  ownedRtvChannels: PropTypes.array,
};

Slot.defaultProps = {
  slot: null,
  ownedFields: [],
  ownedRtvChannels: [],
};

const mapStateToProps = ({login: {profile}, partner: {ownedFields, ownedRtvChannels, isPlayersModalVisible, playersList, affiliations}}) => ({
  profile,
  ownedFields,
  ownedRtvChannels,
  isPlayersModalVisible,
  playersList,
  affiliations
});

const mapDispatchToProps = dispatch => ({
  showMessageRemovingVideo: (message) => {
    dispatch(showMessage('VIDEOS', message));
  },
  showPlayersModal: () => {
    dispatch(showPlayersModal());
  },
  hidePlayersModal: () => {
    dispatch(cleanPlayersReceived());
    dispatch(hidePlayersModal());
  },
  searchPlayers: (playerNickname, playerName, playerSurname, playerAffiliate) => {
    if (playerAffiliate === undefined) playerAffiliate = false;
    if (playerName) playerName = playerName.replace(/ /g,'_');
    if (playerSurname) playerSurname = playerSurname.replace(/ /g,'_');
    if (playerNickname) playerNickname = playerNickname.replace(/ /g,'_');
    const validRegex = /^[A-Za-z0-9_àèéìòù'-]*$/;
    if ((playerName && !playerName.match(validRegex)) || (playerSurname && !playerSurname.match(validRegex)) || (playerNickname && !playerNickname.match(validRegex)))
      dispatch(showMessage('ACCEPTED_CHARACTERS', "ACCEPTED_CHARACTERS_INFO"));
    else dispatch(searchPlayers(playerNickname, playerName, playerSurname, playerAffiliate));
  },
});

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(Slot));
